export class Alert {
    type : string = null;
    message : string = null;
}
